import React from 'react'

const Background = props => (
  <div>
    {props.children}
  </div>
)

export default Background
